require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-ultimate-guide-to-reduce-cart-abandonment.json") })
        }
      }, "path---blog-the-ultimate-guide-to-reduce-cart-abandonment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-ultimate-guide-to-reduce-cart-abandonment!./.cache/json/blog-the-ultimate-guide-to-reduce-cart-abandonment.json
// module id = 506
// module chunks = 231608221292675